import { observer } from 'mobx-react';
import React, { SyntheticEvent, useEffect, useRef, useState } from 'react';
import toast from 'react-hot-toast';
import { isValidTagId } from '../../helpers/validate-helper';
import { FormattedMessage } from 'react-intl';
import { NavLink, useLocation, useParams } from 'react-router-dom';
import noMessageIcon from '../../assets/Images/filterNodata.png';
import { ModuleType } from '../../constants/enums/module-type-enum';
import userSettingEnum from '../../constants/enums/user-setting-enum';
import { useStore } from '../../contexts/store-provider';
import {
  TagFilterDefaultSortColumnOrder,
  TagsFilterInitialState,
} from '../../core/initialState/filter-initial-state';
import {
  isOperationPermittedRoleBase,
  showIconsRoleBase,
} from '../../helpers/action-permission-helper';
import { getTenantIdFromLocalStorage } from '../../helpers/localstorage-helper';
import IPageInfo, {
  IActionFormatter,
  IPageLimitInfo,
} from '../../models/ICommon';
import IDefaultColumSortOrder from '../../models/IDefaultColumSortOrder';
import { ITagsFilter } from '../../models/ITagsFilter';
import FormLoader from '../../shared-components/FormLoader/FormLoader';
import Grid from '../../shared-components/Grid/Grid';
import Pagination from '../../shared-components/Grid/Pagination';
import LoaderButton from '../../shared-components/button/loader-button';
import FilterPopupHOC from '../../shared-components/hoc/filter-popup-hoc/filter-popup-hoc';
import DeletePopup from '../../shared-components/popup/delete/delete-popup';
import DeletePopupHOC from '../../shared-components/popup/delete/delete-popup-hoc';
import RoutesConstants from '../../shared-components/routes/routes-constants';
import {
  CloseSidePanelIcon,
  PlusIcon,
  RightArrowMove,
  ScanIcon,
} from '../../shared-components/svgs/svgs';
import { formatMessage } from '../../translations/format-message';
import FilterComponentNew from './components/filter-form';
import config from '../../helpers/config-helper';

const appConfig = config();
const showAddTrayInput = appConfig.REACT_APP_SHOW_ADD_TRAY_INPUT;
const TagAssignRemove = (props: any) => {
  const [scannedItems, setScannedItems] = useState([]);
  const [scannedBarcode, setScannedBarcode] = useState('');
  const { taskId } = useParams<any>();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const processName = queryParams.get('processName');
  const { processStore, preferencesStore, operatorStore } = useStore();
  const [tagRemoveRows, setTagRemoveRows] = useState([]);
  const [tagId, setTagId] = useState(''); //remove later
  const [removeTrayId, setRemoveTrayId] = useState(''); //remove later
  const [scannedData, setScannedData] = useState('');
  const inputRef = useRef<HTMLInputElement>(null);
  const {
    processList,
    deleteProcessState,
    resetDeleteProcess,
    resetProcessDetail,
    addUpdateProcessState,
    resetAddUpdateProcessState,
  } = processStore;

  const {
    GetFilteredTrays,
    getFilteredTraysState,
    getAllFilteredTrays,
    resetFilteredTraysList,
    AssignTagService,
    assignTagState,
    GetTrayDetailsOnScan,
    getTrayDetailsOnScanState,
    trayDetailComputed,
    RemoveTagService,
    removeTagState,
    resetAssignTagState,
    resetRemoveTagState,
    resetGetTrayDetailsOnScanState,
    filteredTraysList,
    responseData,
  } = operatorStore;

  const {
    userSetting,
    language,
    islanguageChanged,
    updateLanguageChangedFlag,
    setUserSetting,
  } = preferencesStore;

  let lang: string;
  const [scanBuffer, setScanBuffer] = useState('');
  const [lastKeyTime, setLastKeyTime] = useState(Date.now());
  const allFilteredTrays = getAllFilteredTrays;
  const [rows, setRows] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [disablePagination, setDisablePagination] = useState<boolean>(false);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [selectedId, setSelectedId] = useState(-1);
  const [openPanel, setOpenPanel] = useState(false);
  const [isFilterCleared, setIsFilterCleared] = useState(true);
  const [columSortOrder, setColumnSortOrder] = useState<IDefaultColumSortOrder>(
    TagFilterDefaultSortColumnOrder
  );
  const [filterObj, setFilterObj] = useState<ITagsFilter>(
    TagsFilterInitialState
  );

  const pageLimitOptions: Array<number> = [10, 20, 50, 100];

  const getFontSizeClass = (size: 'small' | 'normal' | 'large') => {
    if (size === 'small') return 'opertor-small-text';
    if (size === 'large') return 'opertor-text-large';
    return 'opertor-normal-text';
  };
  const savedFontSize = localStorage.getItem('fontSize');
  const initialFontSize: 'small' | 'normal' | 'large' =
    savedFontSize === 'small' || savedFontSize === 'large'
      ? savedFontSize
      : 'normal';

  const [fontSizeClass, setFontSizeClass] = useState<string>(
    getFontSizeClass(initialFontSize)
  );
  const [activeSize, setActiveSize] = useState<'small' | 'normal' | 'large'>(
    initialFontSize
  );

  const handleFontSizeChange = (size: 'small' | 'normal' | 'large') => {
    localStorage.setItem('fontSize', size);
    setActiveSize(size);
    setFontSizeClass(getFontSizeClass(size));
  };

  useEffect(() => {
    setRows([...getAllFilteredTrays]);
  }, [getAllFilteredTrays]);

  const [pageLimitInfo, setPageLimit] = useState<IPageLimitInfo>({
    pageLimit: userSetting.pageLimitConfig,
    isPageLimitChange: false,
  });

  const [pageInfo, setPageInfo] = useState<IPageInfo>({
    currentPage: 1,
    totalPages: 1,
    isPagerChange: false,
    isRefreshPage: false,
  });

  const getFilteredTraysListServiceHandler = (
    isSearchClicked: boolean = false,
    isPageChanged?: boolean,
    filterQuery?: string
  ) => {
    if (!filterQuery) {
      filterQuery = createQueryString({
        ...filterObj,
        Column: columSortOrder.dataField,
        Order: columSortOrder.order,
      });
    }
    if (isSearchClicked) {
      GetFilteredTrays(
        Number(getTenantIdFromLocalStorage()),
        1,
        pageLimitInfo.pageLimit,
        encodeURIComponent(filterQuery)
      );
      setIsFilterCleared(false);
    } else if (isPageChanged) {
      GetFilteredTrays(
        Number(getTenantIdFromLocalStorage()),
        pageInfo.currentPage,
        pageLimitInfo.pageLimit,
        encodeURIComponent(filterQuery)
      );
    } else {
      GetFilteredTrays(
        Number(getTenantIdFromLocalStorage()),
        pageInfo.currentPage,
        pageLimitInfo.pageLimit,
        encodeURIComponent(filterQuery)
      );
    }
  };

  useEffect(() => {
    resetFilteredTraysList();
  }, []);

  useEffect(() => {
    if (islanguageChanged) {
      updateLanguageChangedFlag();
    }
  }, [islanguageChanged]);

  useEffect(() => {
    setPageInfo({
      ...pageInfo,
      totalPages: filteredTraysList?.PagingDetails?.TotalPages,
      currentPage: filteredTraysList?.PagingDetails?.CurrentPage,
      isPagerChange: false,
    });
    setDisablePagination(false);
  }, [filteredTraysList]);

  useEffect(() => {
    if (!selectedRow) return;
    const handleKeyDown = (e) => {
      if (!e.key) return;
      const currentTime = Date.now();
      const timeDiff = currentTime - lastKeyTime;
      // If key delay is too long, treat it as a new scan
      //ARIF: WHY?? DOES SCAN NEED THIS?? TEST WITHOUT THIS WITH SCANNER
      if (e.target?.tagName === 'INPUT' || e.target?.tagName === 'BUTTON') {
        setScanBuffer(() => '');
      } else {
        if (timeDiff > 100) {
          setScanBuffer(() => e.key);
        } else {
          setScanBuffer((prev) => prev + e.key);
        }
      }
      setLastKeyTime(currentTime);

      if (e.key === 'Enter') {
        const stringsToReplace = ['Shift', 'CapsLock', 'Tab'];
        const cleanedScan = scanBuffer.replace(
          new RegExp(stringsToReplace.join('|'), 'g'),
          ''
        );
        // Proceed with the cleaned scan value
        if (taskId === '-2' && cleanedScan.length > 0) {
          GetTrayDetailsOnScan(
            Number(getTenantIdFromLocalStorage()),
            cleanedScan
          );
        } else {
          if (cleanedScan?.length != 12) {
            //return;
          } else if (selectedRow?.TagId?.length === 0) {
            //alert(formatMessage('enter_valid_tag_id'));
          }
          // toast.error('Please scan a tag id')
          // toast.error(formatMessage('enter_valid_tag_id'));
          // else {
          //   alert(formatMessage('enter_valid_tag_id'));
          // }
          if (isValidTagId(cleanedScan)) {
            setRows((prevRows) =>
              prevRows.map((row) =>
                row.Id === selectedId ? { ...row, TagId: cleanedScan } : row
              )
            );
            handleTask();
          } else if (cleanedScan.length >= 4) {
            toast.error(formatMessage('enter_valid_tag_id'));
          }
        }
        setScanBuffer('');
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [selectedRow, scanBuffer, lastKeyTime]);

  useEffect(() => {
    if (
      getFilteredTraysState.success &&
      allFilteredTrays &&
      allFilteredTrays.length > 0
    ) {
      setSelectedRow(allFilteredTrays[0]);
      setSelectedId(allFilteredTrays[0].Id);
    }
  }, [allFilteredTrays]);

  useEffect(() => {
    if (getFilteredTraysState.error) {
      toast.error(formatMessage(getFilteredTraysState.error));
      resetFilteredTraysList();
    }
  }, [getFilteredTraysState.error]);

  useEffect(() => {
    if (pageInfo.isPagerChange) {
      getFilteredTraysListServiceHandler(false, true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageInfo.currentPage]);

  useEffect(() => {
    if (pageLimitInfo.isPageLimitChange) {
      getFilteredTraysListServiceHandler(false, true);
      setPageLimit({ ...pageLimitInfo, isPageLimitChange: false });
    }
  }, [pageLimitInfo.pageLimit]);

  useEffect(() => {
    if (lang && language !== lang) {
      getFilteredTraysListServiceHandler(false, false);
    }
  }, [language]);

  // useEffect(() => {
  //   if (addUpdateProcessState.success) {
  //     resetAddUpdateProcessState();
  //     getFilteredTraysListServiceHandler();
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [addUpdateProcessState.success]);

  // useEffect(() => {
  //   if (deleteProcessState.success) {
  //     toast.success(formatMessage('deleted_success'));
  //     props.deletePopupToggleHandler();
  //     resetDeleteProcess();
  //     getFilteredTraysListServiceHandler();
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [deleteProcessState.success]);

  useEffect(() => {
    if (assignTagState.error) {
      if (responseData === '') {
        toast.error(formatMessage(assignTagState.error));
      } else {
        const [beforeHash, afterHash] = responseData.split('#');
        if (beforeHash.length === 0 && afterHash.length === 0) {
          toast.error(formatMessage('could_not_connect_to_AIMS_server'));
        } else {
          toast.error(
            `${formatMessage(assignTagState.error)} ${
              beforeHash.length > 0
                ? `SuccessTrayId: ${beforeHash} | FailedTrayId: ${afterHash}`
                : `FailedTrayId: ${afterHash}`
            }`
          );
        }
      }
      // toast.error(
      //   `${
      //     beforeHash.length === 0 && afterHash.length === 0
      //       ? formatMessage('could_not_connect_to_AIMS_server')
      //       : formatMessage(assignTagState.error)
      //   } - ${
      //     beforeHash.length > 0
      //       ? `SuccessTrayId: ${beforeHash} | FailedTrayId: ${afterHash}`
      //       : `FailedTrayId: ${afterHash}`
      //   }`
      // formatMessage(
      //   `${assignTagState.error} ${
      //     beforeHash.length > 0
      //       ? `SuccessTrayId: ${beforeHash} | FailedTrayId: ${afterHash}`
      //       : `FailedTrayId: ${afterHash}`
      //   }`
      // )
      // );
      resetAssignTagState();
    }
  }, [assignTagState.error]);

  useEffect(() => {
    if (removeTagState.error) {
      const [beforeHash, afterHash] = responseData.split('#');
      toast.error(
        formatMessage(
          `${removeTagState.error} ${
            beforeHash.length > 0
              ? `SuccessTrayId: ${beforeHash} | FailedTrayId: ${afterHash}`
              : `FailedTrayId: ${afterHash}`
          }`
        )
      );

      resetRemoveTagState();
    }
  }, [removeTagState.error]);

  useEffect(() => {
    if (assignTagState.success) {
      toast.success(formatMessage('added_success'));
      setFilterObj({ ...TagsFilterInitialState });
      resetAssignTagState();
      getFilteredTraysListServiceHandler(false, false);
    }
  }, [assignTagState.success]);

  // useEffect(() => {
  //   if (assignTagState.success) {
  //     toast.success(formatMessage('added_success'));
  //     setFilterObj({ ...TagsFilterInitialState });
  //     resetAssignTagState();
  //     setIsFilterCleared(true);
  //     const filter = createQueryString({ ...TagsFilterInitialState });
  //     getFilteredTraysListServiceHandler(filter);
  //     getFilteredTraysListServiceHandler();
  //   }
  // }, [assignTagState.success]);

  useEffect(() => {
    if (removeTagState.success) {
      toast.success(formatMessage('removed_success'));
      setTagRemoveRows([]);
      resetRemoveTagState();
    }
  }, [removeTagState.success]);

  function rowClassFormat(row: any, rowId: number) {
    let className: string = '';
    if (selectedRow?.Id && row.Id === selectedRow.Id) {
      className = 'bg-row SelectedRow assign-tags';
    } else {
      if (row?.TagId) {
        className = 'assign-tags';
      } else {
        className = 'assign-tags';
      }
    }
    return className;
  }

  const rowEvents = (e: SyntheticEvent, row: any) => {
    // GetProcessByIdService(row.Id);
    setSelectedRow(row);
    setSelectedId(row.Id);
    // setSelectedId(row.Id);
    // if (selectedRow.Id === undefined || selectedRow.Id !== row.Id) {
    //   setOpenPanel(true);
    // } else {
    //   setOpenPanel(!openPanel);
    // }
  };

  const closePanelHandler = () => {
    setSelectedRow({});
    setOpenPanel(false);
  };

  const handleTagClear = () => {
    if (selectedId === -1) return;

    setRows((prev) => {
      return prev.map((item) => {
        if (item.Id === selectedId) {
          item.TagId = '';
        }
        return item;
      });
    });
    handleTask();
    props.deletePopupToggleHandler();
  };

  // const handleDeleteRow = () => {
  //   if (selectedId === -1) return;

  //   setRows((prev) => {
  //     return prev.filter((item) => item.Id !== selectedId);
  //   });
  //   handleTask();
  // };

  const tagRemoveClickHandler = (
    row: any,
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    event.stopPropagation();
    setSelectedId(row.Id);
    closePanelHandler();
    resetProcessDetail();
    props.deletePopupToggleHandler();
  };

  const openAddProcessHandler = (
    row: { Id: number },
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    event.stopPropagation();
    closePanelHandler();
    resetProcessDetail();
    setSelectedId(row.Id);
    props.addToggleHandler();
  };

  const createQueryString = (filter: ITagsFilter): string => {
    return Object.entries(filter)
      .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
      .join('#');
  };

  const filterHandler = (object: ITagsFilter) => {
    const filters = {
      ...object,
      Column: columSortOrder.dataField,
      Order: columSortOrder.order,
    };
    const filter = createQueryString({ ...filters });
    getFilteredTraysListServiceHandler(true, false, filter);
    setFilterObj({ ...filters });
    props.filterPopupToggleHandler();
    closePanelhandler();
    setIsFilterCleared(false);
  };

  const closePanelhandler = () => {
    setSelectedRow({});
    setOpenPanel(false);
  };

  const filterParams = (obj: ITagsFilter, isfilterCleard: boolean) => {
    if (isfilterCleard) {
      setFilterObj({ ...obj });
      resetFilteredTraysList();
      // getFilteredTraysListServiceHandler(filter);
      closePanelhandler();
      setIsFilterCleared(true);
    } else {
      setFilterObj({ ...obj });
    }
    props.filterPopupToggleHandler();
    setSelectedId(-1);
  };

  const handleTableChange = (type: any, newState: any) => {
    // if (isFirstLoad.current) {
    //   isFirstLoad.current = false;
    //   return;
    // }

    setColumnSortOrder((prevState) => ({
      ...prevState,
      dataField: newState.sortField,
      order: newState.sortOrder,
    }));
  };

  const handleScan = () => {
    inputRef.current?.focus();
  };

  const handleBarcodeInput = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      GetTrayDetailsOnScan(Number(getTenantIdFromLocalStorage()), scannedData);
      setRows((prev) => [
        ...prev.filter((r) => r.Id !== -1),
        { Id: Date.now(), Barcode: scannedData },
      ]);

      setScannedData('');
    }
  };

  const onPageChanged = (pageNumber: number) => {
    closePanelHandler();
    setPageInfo({ ...pageInfo, currentPage: pageNumber, isPagerChange: true });
  };

  const setIsRefreshPage = () => {
    setPageInfo({ ...pageInfo, isRefreshPage: false });
  };

  const onPageLimitChanged = (evt: any) => {
    let pages: number;
    pages = props.data && Math.ceil(props.data.length / evt.target.value);
    setPageInfo({
      ...pageInfo,
      currentPage: 1,
      totalPages: pages,
      isPagerChange: false,
    });
    setPageLimit({
      pageLimit: parseInt(evt.target.value),
      isPageLimitChange: true,
    });
    setUserSetting(userSettingEnum.UserLimitConfig, parseInt(evt.target.value));
  };

  useEffect(() => {
    if (getTrayDetailsOnScanState.success) {
      setTagRemoveRows((prev) => {
        const withoutDummy = prev.filter((row) => row.Id !== -1);
        const isExist = prev.find((item) => item.Id === trayDetailComputed.Id);
        let result = [...withoutDummy];
        if (!isExist) {
          result = [trayDetailComputed, ...result];
        } else {
          toast.error(formatMessage('TrayIdAlreadyAdded'));
        }

        return [...result];
      });
      resetGetTrayDetailsOnScanState();
    }
  }, [trayDetailComputed]);

  const actionIcons: IActionFormatter[] = showIconsRoleBase(
    [
      {
        dataField: 'isClear',
        handler: tagRemoveClickHandler,
        icon: <CloseSidePanelIcon />,
        isDisable: false,
        //   !isOperationPermittedRoleBase(ModuleType.ProcessManagement, 'Delete'),
        title: 'delete',
        varient: 'danger',
        action: 'clear',
        hidden: taskId === '-2',
      },
      // {
      //   dataField: 'isDelete',
      //   handler: deleteClickHandler,
      //   icon: <DeleteIcon />,
      //   isDisable: false,
      //   //   !isOperationPermittedRoleBase(ModuleType.ProcessManagement, 'Delete'),
      //   title: 'delete',
      //   varient: 'danger',
      //   action: 'delete',
      //   hidden: taskId === '-2',
      // },
      {
        dataField: 'isScan',
        handler: handleScan,
        icon: <ScanIcon />,
        isDisable: false,
        title: 'qr_code_scanner',
        varient: 'primary',
        action: 'delete',
        hidden: taskId === '-1',
      },
    ],
    ModuleType.ProcessManagement
  );

  const columns: any = [
    {
      dataField: 'serialNumber',
      text: formatMessage('serial_number'),
      classes: 'show-Elipses',
      isDummyField: true,
      formatter: (_: any, __: any, rowIndex: number) => rowIndex + 1,
      sort: false,
    },
    {
      dataField: 'TrayId',
      text: formatMessage('tray_id'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell && cell.length > 10 ? cell : undefined;
      },
      sort: false,
    },
    {
      dataField: 'EndUserId',
      text: formatMessage('end_user_order_id_short'),
      sort: false,
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell && cell.length > 10 ? cell : undefined;
      },
    },
    {
      dataField: 'Group',
      text: formatMessage('group'),
      sort: false,
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell && cell.length > 10 ? cell : undefined;
      },
    },
    {
      dataField: 'TagId',
      text: formatMessage('assigned_tag_id'),
      classes: 'show-Elipses',
      hidden: taskId === '-2',
      formatter: (cell) => {
        let highlightClass = '';
        if (cell) {
          highlightClass = 'tagID badge';
        }
        return <div className={`${highlightClass}`}>{cell}</div>;
      },
      title: (cell: string) => {
        return cell && cell.length > 10 ? cell : undefined;
      },
    },
    // {
    //   dataField: '',
    //   formatter: CustomActionFormatter(actionIcons),
    //   text: formatMessage('actions'),
    //   classes: 'last-column',
    //   hidden: actionIcons.length > 0 ? false : true,
    //   isDummyField: true,
    // },
  ];

  const selectRow = {
    mode: 'checkbox',
    clickToSelect: true,
    selected: selectedId ? [selectedId] : [],
    onSelect: (row, isSelect) => {
      if (!isSelect) {
        return false;
      }
      setSelectedId(row.Id);
      setScannedBarcode('');
    },
    nonSelectable: rows.map((row) => row.Id),
    hideSelectAll: true,
    selectionRenderer: ({ checked }) => {
      return checked && <RightArrowMove />;
    },
  };

  const handleTask = () => {
    if (selectedId === -1) return;

    const currentIndex = allFilteredTrays.findIndex(
      (row) => row.Id === selectedId
    );
    if (currentIndex < allFilteredTrays.length - 1) {
      setSelectedId(allFilteredTrays[currentIndex + 1].Id);
      setSelectedRow(allFilteredTrays[currentIndex + 1]);
    }
    // else {
    //   setSelectedId(allFilteredTrays[0].Id);
    //   setSelectedRow(allFilteredTrays[0]);
    // }

    // getFilteredTraysListServiceHandler();
  };

  useEffect(() => {
    if (rows.length === 0) {
      setSelectedId(-1);
    }
  }, [rows]);

  return (
    <>
      <div className={`operator-wrapper ${fontSizeClass}`}>
        {props.showDeletePopup && (
          <DeletePopup
            title="clear_tag"
            modalSubmit={handleTagClear}
            modalClosed={props.deletePopupToggleHandler}
            message="message_clear_tag_confirm"
            isLoading={deleteProcessState.inProgress}
          />
        )}

        <div className="icon-nav navbar-fixed-top device-nav-bar userTopNav">
          <div className="row align-items-center">
            <div className="col-lg-5 col-md-6 col-sm-6">
              <div className="page_title_wrap">
                <ul className="add-list operator-back">
                  <li className="process-chart">
                    <NavLink
                      title={formatMessage('operator_list_detail')}
                      to={RoutesConstants.OperatorListDetail}
                      className="btn btn-secondary"
                      // onClick={resetOperatorResponse}
                    >
                      <FormattedMessage id="back" />
                    </NavLink>
                  </li>
                  <li>
                    <h1 className="page_title">{formatMessage(processName)}</h1>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-lg-7 col-md-6 col-sm-6">
              <div className="pe-4 d-flex justify-content-end">
                {taskId === '-1' ? (
                  <>
                    {/* Do not remove */}
                    {/* remove later start */}
                    {showAddTrayInput && (
                      <>
                        <div className="mx-2">
                          <input
                            className="form-control"
                            type="text"
                            value={tagId}
                            placeholder="Tag Id"
                            onChange={(e) => {
                              setTagId(e.target.value);
                            }}
                          />
                        </div>
                        <div className="mx-2">
                          <button
                            className="btn btn-primary"
                            onClick={() => {
                              if (isValidTagId(tagId.trim())) {
                                setRows((prevRows) =>
                                  prevRows.map((row) =>
                                    row.Id === selectedId
                                      ? { ...row, TagId: tagId }
                                      : row
                                  )
                                );
                                handleTask();
                              } else {
                                toast.error(formatMessage('enter_valid_tag_id'));
                              }
                              setTagId('');
                            }}
                          >
                            + {formatMessage('add')}
                          </button>
                        </div>
                      </>
                    )}
                    {/* remove later end */}
                    <div
                      title={formatMessage('assign_tag')}
                      className=""
                    >
                      <a
                        className={`btn btn-secondary ${
                          selectedId === -1 ||
                          !rows.some((item) => item.TagId?.trim())
                            ? 'disabled'
                            : ''
                        }`}
                        data-toggle="modal"
                        data-testid="modalbtn"
                        data-target="#addUser"
                        onClick={() => {
                          const assignedTags = rows
                            .map((item) => item.TagId?.trim())
                            .filter(Boolean);
                          const tagSet = new Set<string>();

                          const hasDuplicates = assignedTags.some((tag) => {
                            if (tagSet.has(tag)) {
                              return true;
                            }
                            tagSet.add(tag);
                            return false;
                          });

                          if (hasDuplicates) {
                            toast.error(
                              formatMessage('multiple_tag_ids_found')
                            );
                            return;
                          }

                          AssignTagService({
                            TenantId: Number(getTenantIdFromLocalStorage()),
                            TagTrays: rows.filter((item) => item.TagId),
                            IsTagReassigned: false,
                          });
                        }}
                      >
                        <span className="me-1">
                          {' '}
                          <PlusIcon />
                        </span>
                        {<FormattedMessage id="assign_tag" />}
                      </a>
                    </div>
                  </>
                ) : (
                  <>
                    {/* Do not remove */}
                    {showAddTrayInput && (
                      <>
                        <div>
                          <div className="mx-2">
                            <input
                              className="form-control"
                              type="text"
                              placeholder={formatMessage('tray_id')}
                              value={removeTrayId}
                              onChange={(e) => {
                                setRemoveTrayId(e.target.value);
                              }}
                            />
                          </div>
                        </div>
                        <div>
                          <button
                            className="btn btn-primary"
                            onClick={() => {
                              GetTrayDetailsOnScan(
                                Number(getTenantIdFromLocalStorage()),
                                removeTrayId
                              );
                              setTagRemoveRows((prevRows) =>
                                prevRows.map((row) =>
                                  row.Id === selectedId
                                    ? { ...row, TagId: '' }
                                    : row
                                )
                              );
                              setRemoveTrayId('');
                              // resetGetTrayDetailsOnScanState();
                            }}
                          >
                            <span className="me-1">
                              {' '}
                              <PlusIcon />
                            </span>{' '}
                            {formatMessage('add')}
                          </button>
                        </div>
                      </>
                    )}
                    {/* Do not remove */}

                    <div
                      className="mx-2"
                      title={formatMessage('remove_tag')}
                    >
                      <a
                        className={`btn btn-secondary ${tagRemoveRows.length === 0 ? 'disabled' : ''}`}
                        data-toggle="modal"
                        data-testid="modalbtn"
                        data-target="#addUser"
                        onClick={() => {
                          RemoveTagService({
                            TenantId: Number(getTenantIdFromLocalStorage()),
                            TrayId: tagRemoveRows
                              .filter((item) => item.Id >= 0)
                              .map((item) => item.TrayId),
                          });
                        }}
                      >
                        <span className="me-1">
                          {' '}
                          <PlusIcon />
                        </span>
                        {<FormattedMessage id="remove_tag" />}
                      </a>
                    </div>
                  </>
                )}

                <ul className="d-flex font-size-increase text-white justify-content-between text-white">
                  <li
                    className={`font-reduce ${activeSize === 'small' ? 'active' : ''}`}
                    onClick={() => handleFontSizeChange('small')}
                  >
                    A-
                  </li>
                  <li
                    className={`font-normal ${activeSize === 'normal' ? 'active' : ''}`}
                    onClick={() => handleFontSizeChange('normal')}
                  >
                    A
                  </li>
                  <li
                    className={`font-increase ${activeSize === 'large' ? 'active' : ''}`}
                    onClick={() => handleFontSizeChange('large')}
                  >
                    A+
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className={`${openPanel ? 'panelOpen' : ''}`}>
          <div className="card card-page">
            {(getFilteredTraysState.inProgress ||
              assignTagState.inProgress ||
              getTrayDetailsOnScanState.inProgress ||
              removeTagState.inProgress) && (
              <FormLoader
                loading={
                  getFilteredTraysState.inProgress ||
                  assignTagState.inProgress ||
                  getTrayDetailsOnScanState.inProgress ||
                  removeTagState.inProgress
                }
              />
            )}

            {taskId === '-1' ? (
              <div>
                <FilterComponentNew
                  initialValues={filterObj}
                  submitHandler={filterHandler}
                  filterParmas={filterParams}
                  isFilterCleared={isFilterCleared}
                  isLoading={false}
                />{' '}
                {rows && rows.length > 0 ? (
                  <>
                    <div className="opertor-dummy">
                      <div className="tableDesign row-eq-height tableDevices p-3 assign-tag-remove">
                        <div
                          className="table-responsive"
                          data-testid="table"
                        >
                          {rows && (
                            <Grid
                              data={rows}
                              columns={columns}
                              keyField="Id"
                              loading={false}
                              rowClasses={rowClassFormat}
                              rowEvents={{ onClick: rowEvents }}
                              hover={true}
                              onTableChange={handleTableChange}
                              selectRow={selectRow}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                    {rows.length > 0 ? (
                      <div className="row no-gutters p-3 pt-0 tableFooter">
                        <div className="col-lg-3 col-md-6 col-sm-6 pt-1">
                          <FormattedMessage id="show" />
                          <select
                            data-testid="pageSelect"
                            className="pageLimit"
                            onChange={onPageLimitChanged}
                            value={pageLimitInfo.pageLimit}
                          >
                            {pageLimitOptions.map((op: any) => (
                              <option
                                key={op}
                                value={op}
                              >
                                {op}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="col-lg-9 col-md-6 col-sm-6 d-flex justify-content-sm-end">
                          <Pagination
                            isRefreshPage={false}
                            totalPages={pageInfo.totalPages}
                            pageLimit={pageLimitInfo.pageLimit}
                            onPageChanged={onPageChanged}
                            disablePagination={disablePagination}
                            setIsRefreshPage={setIsRefreshPage}
                            currentPage={pageInfo.currentPage}
                            totalRecords={
                              filteredTraysList.PagingDetails.TotalRecords
                            }
                          />
                        </div>
                      </div>
                    ) : (
                      ''
                    )}
                  </>
                ) : (
                  <div className="message tagAssignMessage">
                    <div className="d-flex message-area">
                      <div className="no-data-img">
                        <img
                          src={noMessageIcon}
                          alt=""
                          className="no_message"
                        />
                      </div>
                      <div>
                        <h3 className="fw-bold display-6">
                          {' '}
                          <FormattedMessage id={isFilterCleared ? 'no_filters' : 'no_record'} />
                        </h3>
                        <h4 className="mb-3">
                          {formatMessage(isFilterCleared ? 'no_filter_message' : 'no_tray_assign_message')}
                        </h4>
                        {/* {isOperationPermittedRoleBase(
                          ModuleType.ProcessManagement,
                          'Add'
                        ) && (
                          <LoaderButton
                            text="add_process"
                            onClick={(event: any) =>
                              openAddProcessHandler({ Id: -1 }, event)
                            }
                          />
                        )} */}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ) : (
              <>
                <div>
                  <div className="tableDesign row-eq-height tableDevices p-3 tag-remove">
                    <div
                      className="table-responsive"
                      data-testid="table"
                    >
                      {/* <input
                        ref={inputRef}
                        value={scannedData}
                        onChange={(e) => setScannedData(e.target.value)}
                        onKeyDown={handleBarcodeInput}
                        style={{ position: 'absolute', left: '-9999px' }} // hidden input
                      /> */}
                      {
                        <Grid
                          data={tagRemoveRows}
                          columns={columns}
                          keyField="Id"
                          loading={false}
                          rowClasses={rowClassFormat}
                          rowEvents={{ onClick: rowEvents }}
                          hover={true}
                          onTableChange={handleTableChange}
                          // selectRow={selectRow}
                        />
                      }
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default FilterPopupHOC(DeletePopupHOC(observer(TagAssignRemove)));
